import {useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {baseUrl, ipAddress} from './Univ';
function Register() {
    const [formData, setFormData] = useState({
        username: "",
        mobile: "",
        password: "",
        pincode: "",
        userType: "",
        work_type: [],
        cost: "",
        unit: "",
        availability: true
    });
    const handleChange = (e) => {
        const {name, value} = e.target;
        if (name === "mobile") {
            const digitsOnly = value.replace(/\D/g, "").slice(0, 10);
            setFormData((prev) => ({
                ...prev,
                mobile: digitsOnly,
            }));
            return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleCheckboxChange = (e) => {
        const {value, checked} = e.target;
        if (checked) {
            if (!formData.work_type.includes(value)) {
                setFormData({
                    ...formData,
                    work_type: [...formData.work_type, value]
                });
            }
        } else {
            setFormData({
                ...formData,
                work_type: formData.work_type.filter(
                    (item) => item !== value
                )
            });
        }
    };
    const submitForm = async (e) => {
        e.preventDefault();
        try {
            if (
                !formData.username ||
                !formData.mobile ||
                !formData.password ||
                !formData.pincode ||
                !formData.userType
            ) {
                Swal.fire(
                    "Error",
                    "Fill all required fields",
                    "error"
                );
                return;
            }
            if (
                formData.userType === "Worker" &&
                (
                    formData.work_type.length === 0 ||
                    !formData.unit
                )
            ) {
                Swal.fire(
                    "Error",
                    "Select Work Type and Unit",
                    "error"
                );
                return;
            }
            const fd = new FormData();
            fd.append("username", formData.username);
            fd.append("mobile", formData.mobile);
            fd.append("password", formData.password);
            fd.append("pincode", formData.pincode);
            fd.append("userType", formData.userType);
            fd.append("ip_add", ipAddress);
            // Worker fields only
            if (formData.userType === "Worker") {
                fd.append(
                    "work_type",
                    formData.work_type.join(",")
                );
                fd.append("availability", true);
                fd.append("cost", formData.cost);
                fd.append("unit", formData.unit);
            }
            const res = await axios.post(
                `${baseUrl}user-register/`,
                fd
            );
            Swal.fire(
                "Success",
                res.data.msg || "Registered Successfully",
                "success"
            );
            setTimeout(() => {
                window.location.href = '/user-login/';
            }, 3000);
        } catch (err) {
            console.log(err.response?.data);
            Swal.fire(
                "Error",
                err.response?.data?.error ||
                err.response?.data?.msg ||
                "Registration Failed",
                "error"
            );
        }
    };
    return (
        <section className="container mt-4">
            <h3
                className="text-center"
                style={{
                    color: "white",
                    backgroundColor: "#0dcaf0"
                }}
            >
                User Registration
            </h3>

            <form>
                <table className="table table-bordered mt-3">
                    <tbody>

                    <tr>
                        <td>User Name</td>
                        <td>
                            <input
                                type="text"
                                className="form-control"
                                name="username"
                                value={formData.username}
                                onChange={handleChange}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>Mobile</td>
                        <td>
                            <input
                                type="text"
                                className="form-control"
                                name="mobile"
                                maxLength={10}
                                value={formData.mobile}
                                onChange={handleChange}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>Pincode</td>
                        <td>
                            <input
                                type="number"
                                className="form-control"
                                name="pincode"
                                value={formData.pincode}
                                onChange={handleChange}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>User Type</td>
                        <td>
                            <select
                                className="form-control"
                                name="userType"
                                value={formData.userType}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Select User Type
                                </option>

                                <option value="LandOwner">
                                    Land Owner
                                </option>

                                <option value="Worker">
                                    Worker
                                </option>
                            </select>
                        </td>
                    </tr>

                    {formData.userType === "Worker" && (
                        <>
                            <tr>
                                <td>Work Type</td>
                                <td>

                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            value="Food Grain"
                                            className="form-check-input"
                                            onChange={handleCheckboxChange}
                                            checked={formData.work_type.includes(
                                                "Food Grain"
                                            )}
                                        />
                                        <label>
                                            Food Grain
                                        </label>
                                    </div>

                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            value="Pulses"
                                            className="form-check-input"
                                            onChange={handleCheckboxChange}
                                            checked={formData.work_type.includes(
                                                "Pulses"
                                            )}
                                        />
                                        <label>
                                            Pulses
                                        </label>
                                    </div>

                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            value="Cash Crops"
                                            className="form-check-input"
                                            onChange={handleCheckboxChange}
                                            checked={formData.work_type.includes(
                                                "Cash Crops"
                                            )}
                                        />
                                        <label>
                                            Cash Crops
                                        </label>
                                    </div>

                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            value="Horticultural Crop"
                                            className="form-check-input"
                                            onChange={handleCheckboxChange}
                                            checked={formData.work_type.includes(
                                                "Horticultural Crop"
                                            )}
                                        />
                                        <label>
                                            Horticultural Crop
                                        </label>
                                    </div>

                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            value="Plantation Crop"
                                            className="form-check-input"
                                            onChange={handleCheckboxChange}
                                            checked={formData.work_type.includes(
                                                "Plantation Crop"
                                            )}
                                        />
                                        <label>
                                            Plantation Crop
                                        </label>
                                    </div>

                                    <div>
                                        <b>Selected:</b>{" "}
                                        {formData.work_type.join(", ")}
                                    </div>

                                </td>
                            </tr>

                            <tr>
                                <td>Cost</td>
                                <td>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="cost"
                                        value={formData.cost}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td>Unit</td>
                                <td>
                                    <select
                                        name="unit"
                                        className="form-control"
                                        value={formData.unit}
                                        onChange={handleChange}
                                    >
                                        <option value="">
                                            Select Unit
                                        </option>

                                        <option value="Per Day">
                                            Per Day
                                        </option>

                                        <option value="Per Acre">
                                            Per Acre
                                        </option>

                                        <option value="Per Hectare">
                                            Per Hectare
                                        </option>

                                        <option value="Per Task">
                                            Per Task
                                        </option>

                                        <option value="Contract Basis">
                                            Contract Basis
                                        </option>
                                    </select>
                                </td>
                            </tr>
                        </>
                    )}

                    <tr>
                        <td>Password</td>
                        <td>
                            <input
                                type="password"
                                className="form-control"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="2" className="text-center">
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={submitForm}
                            >
                                Register
                            </button>
                        </td>
                    </tr>

                    </tbody>
                </table>
            </form>
        </section>
    );
}
export default Register;